import styled, { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

const workspaceLogoSize = 34;

export const StyledWrapper = styled.a<{
  isWorkspace: boolean;
}>(({ theme, isWorkspace }) => {
  const logoSize = isWorkspace ? workspaceLogoSize : theme.Components.Logo.Size;

  return css`
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: ${utils.rem(40)};
    margin: 0 ${({ theme }) => utils.rem(theme.Sizes.Medium)};
    svg {
      fill: ${theme.Components.Logo.Color};
      width: auto;
      height: ${utils.rem(logoSize)};
    }

    img {
      width: auto;
      height: ${utils.rem(logoSize)};
    }
  `;
});
